export type HttpMessage = {
	message: string;
	status: number;
};

export enum Status {
	Success = 'success',
	Error = 'error'
}
